import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';



import Faixas from './pages/Faixas';
import Regras from './pages/Regras';
import Gruposegur from './pages/Gruposegur';
import Movimentacao from './pages/Movimentacao';
import Consolidacao from './pages/Consolidacao';
import Convencao from './pages/Convencao';
import Cursos from './pages/Cursos';
import Participantes from './pages/Participantes';
import CertModelos from './pages/CertModelos';
import CertModeloEditor from './pages/CertModeloEditor';
import EmitirCertificados from './pages/EmitirCertificados';
import Cliente from './pages/Cliente';
import Lancamentos from './pages/Lancamentos';
import Relatorio from './pages/Relatorio';
import Demandas from './pages/Demandas';
import Profile from './pages/Profile';
import ChangePassword from './pages/ChangePassword';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Permissoes from './pages/Permissoes';
import Marketing from './pages/Marketing';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              
              {/* Protected Routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }>
                {/* Dashboard Routes */}
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Navigate to="/" replace />} />
      
      

                <Route path="faixas" element={<Faixas />} />
<Route path="gruposegur" element={<Gruposegur />} />
<Route path="regras" element={<Regras />} />
<Route path="movimentacao" element={<Movimentacao />} />
<Route path="consolidacao" element={<Consolidacao />} />
<Route path="convencao" element={<Convencao />} />
<Route path="cursos" element={<Cursos />} />
<Route path="participantes" element={<Participantes />} />
<Route path="cert-modelos" element={<CertModelos />} />
<Route path="cert-modelos/:id/editar" element={<CertModeloEditor />} />
<Route path="emitir-certificados" element={<EmitirCertificados />} />
                <Route path="cliente" element={<Cliente />} />
                <Route path="lancamentos" element={<Lancamentos />} />
                <Route path="relatorio" element={<Relatorio />} />
                <Route path="demandas" element={<Demandas />} />
                <Route path="marketing/*" element={<Marketing />} />
                
                <Route path="permissoes" element={<ProtectedRoute requireAdmin><Permissoes /></ProtectedRoute>} />
                
                {/* User Routes */}
                <Route path="profile" element={<Profile />} />
                <Route path="perfil" element={<Profile />} />
                <Route path="change-password" element={<ChangePassword />} />
                <Route path="configuracoes" element={<Settings />} />
                
                {/* Admin Routes */}
                <Route path="usuarios" element={
                  <ProtectedRoute requireAdmin>
                    <Users />
                  </ProtectedRoute>
                } />
              </Route>
              
              
              
              {/* Catch all route - redirect to dashboard */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            
            {/* Toast notifications */}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#10B981',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#EF4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
